import {HashRouter, Routes, Route} from 'react-router-dom';
import {NavbarContainer} from './components/templates/navbar/Navbar';
import ChartContextProvider from './store/ChartContext';
import AuthProvider from './store/AuthContext';
import Subscriptions from "./views/subscriptions";
import Home from "./views/home";
import BasicSubscription from "./views/subscriptions/basicSubscription";
import ExpertMonthlySubscription from "./views/subscriptions/expertMonthlySubscription";
import ExpertYearlySubscription from "./views/subscriptions/expertYearlySubscription";
import ProMonthlySubscription from "./views/subscriptions/proMonthlySubscription";
import ProYearlySubscription from "./views/subscriptions/proYearlySubscription";
import Footer from "./components/footer";
import GTMPageTracker from "./GTMPageTracker";

// Suppress React errors and warnings during build
if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.error = noop;
    console.warn = noop;
}

export const App = props => {
    return (
        <AuthProvider>
            <ChartContextProvider>
                <HashRouter>
                    <GTMPageTracker />
                    <Routes>
                        <Route exact path="/" element={<Home/>}/>
                        <Route path="/subscriptions" element={<Subscriptions/>}/>
                        <Route path="/subscriptions/basic" element={<BasicSubscription/>}/>
                        <Route path="/subscriptions/expert-monthly" element={<ExpertMonthlySubscription/>}/>
                        <Route path="/subscriptions/expert-yearly" element={<ExpertYearlySubscription/>}/>
                        <Route path="/subscriptions/pro-monthly" element={<ProMonthlySubscription/>}/>
                        <Route path="/subscriptions/pro-yearly" element={<ProYearlySubscription/>}/>
                        <Route path="*" element={<Home/>}/>
                    </Routes>
                    <Footer />
                </HashRouter>
            </ChartContextProvider>
        </AuthProvider>
    );
}

export default App;